/* ZAYIN / INTERACTIONS v1: reveal cards as they enter view.
   Does not intercept clicks, submit events, navigation, cart, or checkout. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches) return;
  const main = document.getElementById('MainContent');
  if (!main) return;
  const selector = '.product-card, .collection-card, .resource-card, .zw-style-card';
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.setAttribute('data-zayin-reveal', 'visible');
      observer.unobserve(entry.target);
    }
  }, { rootMargin:'0px 0px -16px 0px', threshold:0.07 });
  const apply = (root) => {
    const cards = [];
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1 && root.matches?.(selector)) cards.push(root);
    root.querySelectorAll?.(selector).forEach((card) => cards.push(card));
    for (const card of cards) {
      if (card.hasAttribute('data-zayin-reveal')) continue;
      if (card.closest('header-component, .header-drawer')) continue;
      card.style.setProperty('--zayin-reveal-delay', '0ms');
      card.setAttribute('data-zayin-reveal','pending');
      observer.observe(card);
    }
  };
  apply(main);
  document.addEventListener('shopify:section:load', (event) => {
    if (main.contains(event.target)) apply(event.target);
  });
  /* Horizon updates related products asynchronously after scrolling. */
  const mutationObserver = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) apply(node);
      }
    }
  });
  mutationObserver.observe(main, { childList:true, subtree:true });
  motion.addEventListener?.('change', (event) => {
    if (!event.matches) return;
    observer.disconnect();
    mutationObserver.disconnect();
    main.querySelectorAll('[data-zayin-reveal]').forEach((card) => {
      card.setAttribute('data-zayin-reveal','visible');
    });
  });
})();
